import { ApiService } from '../Services/APIService';
import { ENDPOINTS } from '../Utils/APIConstants';
import { StorageUtils } from "../Utils/StorageUtils";  

export const AuthService = {
  // signup: (userData) => ApiService.post(ENDPOINTS.SIGNUP, userData),
  signup: (userData) => {
  const formData = new FormData();
  
  // Append text fields
  formData.append('name', userData.name);
  formData.append('email', userData.email);
  formData.append('password', userData.password);

  // Append image only if selected
  if (userData.image) {
    formData.append('profile_image', userData.image); // Make sure backend expects 'image'
  }

  return ApiService.post(ENDPOINTS.SIGNUP, formData, true); // Pass true to indicate multipart
},
  login: (credentials) => ApiService.post(ENDPOINTS.LOGIN, credentials),
  googleLogin: (tokenData) => ApiService.post(ENDPOINTS.GOOGLE_LOGIN, tokenData),
  updateProfile: async (profileData) => {
      // Retrieve the token from StorageUtils
      const token = StorageUtils.getUserData()?.token;
  
      // Set the token in ApiService
      ApiService.setAuthToken(token);
  return ApiService.upload(ENDPOINTS.UPDATE_PROFILE, profileData);
      // Make the API call
      // return ApiService.put(ENDPOINTS.UPDATE_PROFILE, profileData);
    },
  deleteAccount: (tokenData) => ApiService.delete(ENDPOINTS.DELETE_ACCOUNT),

};